const displayLayoutDrawingObjectTypes = {
  'box-view': {
    name: 'Box',
    creatable: false,
    description: 'A rectangle shape.',
    cssClass: 'icon-box-round-corners'
  },
  'ellipse-view': {
    name: 'Ellipse',
    creatable: false,
    description: 'A ellipse shape.',
    cssClass: 'icon-circle'
  },
  'line-view': {
    name: 'Line',
    creatable: false,
    description: 'A line.',
    cssClass: 'icon-line-horz'
  },
  'text-view': {
    name: 'Text',
    creatable: false,
    description: 'An editable text box.',
    cssClass: 'icon-font'
  },
  'image-view': {
    name: 'Image',
    creatable: false,
    description: 'An image.',
    cssClass: 'icon-image'
  }
};

export default displayLayoutDrawingObjectTypes;
